import { Fragment } from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon, Text } from '@ui-kitten/components';

import Button from '../../Components/Button';
import themeStyle from '../../Theme/styles';
import { SECTION_SUB_TITLE } from '../../Theme/typographyProps';

type Value = '1' | '2';
const options: { text: string; icon: string; value: Value }[] = [
  {
    text: 'Standard',
    icon: 'motorcycle',
    value: '1',
  },
  {
    text: 'Priority',
    icon: 'bolt',
    value: '2',
  },
];

const DeliverySpeed = ({
  enabled,
  isLalamove,
  isLoading,
  value = '1',
  onChange = () => {},
}: {
  enabled: boolean;
  isLalamove?: boolean;
  isLoading?: boolean;
  value?: Value;
  onChange?: (selected: Value) => void;
}) => {
  if ((!isLoading && !isLalamove) || !enabled) return null;
  return (
    <View accessibilityRole="radiogroup">
      <Text style={themeStyle.spacingBottomMedium} {...SECTION_SUB_TITLE}>
        Delivery Speed
      </Text>
      <View style={themeStyle.flexDirectionRow}>
        {options.map((option, index) => {
          return (
            <Fragment key={option.text}>
              <Button
                accessibilityRole="radio"
                appearance="outline"
                disabled={isLoading}
                status={value === option.value ? 'success' : 'basic'}
                style={styles.btn}
                onPress={() => onChange(option.value)}
              >
                {(props) => (
                  <View style={themeStyle.alignItemsCenter}>
                    <Icon
                      name={option.icon}
                      pack="fa"
                      fill={props.style.color}
                      style={styles.icon}
                    />
                    <Text category="p2" {...props}>
                      {option.text}
                    </Text>
                  </View>
                )}
              </Button>
              {index < options.length - 1 && (
                <View style={themeStyle.rowSeparator} />
              )}
            </Fragment>
          );
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  icon: {
    width: 20,
    height: 20,
  },
  btn: {
    ...themeStyle.flex1,
    borderRadius: 10,
    borderWidth: 1,
    maxWidth: 200,
    paddingVertical: 10,
  },
});

export default DeliverySpeed;
